<template>
  <!--  VISTA LISTAR-->
  <template v-if="view==='listar'">
    <HeaderComponent :title="title" :entity="entity" :clean-form="cleanLoadSelectedData" @updateValues="setupUpdateValues"></HeaderComponent>
    <FilterRefactComponent :auth-token="authToken" :list-api="listApi" :table-columns="tableColumns" :queries="queries"
                           @updateValues="setupUpdateValues"></FilterRefactComponent>
    <TableComponent :entity="entity" :selected-data="selectedBanco" :table-columns="tableColumns"
                    :collection-data="collectionData"
                    :auth-token="authToken" :list-api="listApi" @updateValues="setupUpdateValues"></TableComponent>
    <PaginateRefactComponent :auth-token="authToken" :list-api="listApi" :paginate="paginate"
                             :optionalParams="queries"
                             @updateValues="setupUpdateValues"></PaginateRefactComponent>
  </template>
  <!--    VISTA CREAR - ACTUALIZAR-->
  <template v-else>
    <CreateUpdateComponent :view="view" :paginate="paginate" :selected-data="selectedBanco" :load-data="loadDataBanco"
                           :entity="entity" :auth-token="authToken" :list-api="listApi" :queries="queries"
                           @updateValues="setupUpdateValues">
      <component :is="childFormComponent" :load-data="loadDataBanco" @updateValues="setupUpdateValues"></component>
    </CreateUpdateComponent>
  </template>
</template>
<script>
import {reactive, ref} from "vue";
import {useAuth} from "@/components/auth/store/composables";
import HeaderComponent from "@/layouts/main/HeaderComponent";
import TableComponent from "@/layouts/main/TableComponent";
import CreateUpdateComponent from "@/layouts/main/CreateUpdateComponent";
import FilterRefactComponent from "@/layouts/FilterRefactComponent";
import PaginateRefactComponent from "@/layouts/PaginateRefactComponent";
import BancosCrearActualizarComponent from "@/components/parametros/components/BancosCrearActualizarComponent";
import {useLayoutMain} from "@/layouts/main";

export default {
  name: 'BancosCRUD',
  components: {
    HeaderComponent,
    FilterRefactComponent,
    TableComponent,
    PaginateRefactComponent,
    CreateUpdateComponent,
    BancosCrearActualizarComponent
  },
  data: function () {
    return {
      Object: Object,
      title: 'Bancos',
      entity: {gender: 'm', value: 'banco'},
      childFormComponent: 'bancosCrearActualizarComponent',
      tableColumns: {
        'id': {
          isFilter: false,
          isOrder: false,
          isVisibleInTable: true,
          value: 'ID'
        },
        'nombre_banco': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: true,
          value: 'Nombre del banco'
        },
        'estado': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: 'Estado'
        },
        'created_at': {
          isFilter: true,
          isOrder: true,
          isVisibleInTable: false,
          value: 'Fecha de creación'
        }
      }
    }
  },
  async setup() {
    const authStored = useAuth();
    const view = ref('listar');
    const collectionData = ref([]);
    const authToken = ref(authStored.authToken);
    const selectedBanco = ref({
      id: '',
      nombre_banco: '',
      estado: ''
    });
    const loadDataBanco = ref({
      nombre_banco: ''
    });
    const listApi = reactive({
      create: process.env.VUE_APP_NEST_BANCO_CREATE,
      list: process.env.VUE_APP_NEST_BANCO_FINDALL,
      update: process.env.VUE_APP_NEST_BANCO_UPDATE,
      updateState: process.env.VUE_APP_NEST_BANCO_UPDATESTATE
    });
    const {
      paginate,
      queries,
      setupUpdateValues,
      cleanLoadSelectedData
    } = await useLayoutMain(view, collectionData, authToken, selectedBanco, loadDataBanco, listApi);
    return {
      view,
      collectionData,
      authToken,
      selectedBanco,
      loadDataBanco,
      listApi,
      paginate,
      queries,
      setupUpdateValues,
      cleanLoadSelectedData
    };
  }
}
</script>